// utils/dateUtils.js

export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return ""; // Return an empty string if dateTimeString is null or undefined

  // Check if the string contains a space to determine the format
  const isEndDate = dateTimeString.includes(" ");

  let datePart, timePart;
  if (isEndDate) {
    // For "ENDATE": "YYYY-MM-DD HH:MM:SS" format
    [datePart, timePart] = dateTimeString.split(" ");
  } else {
    // For "ORDERTIME": "HH:MM:SS.mmmmmmm" format
    datePart = ""; // No date part
    timePart = dateTimeString;
  }

  const date = formatDate(datePart); // Format date using existing formatDate function
  const time = formatTime(timePart); // Format time using existing formatTime function

  return { date, time };
};

export const formatDate = (dateString) => {
  if (!dateString) return ""; // Return an empty string if dateString is null or undefined

  const dateTime = new Date(dateString);
  const date = dateTime.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return date;
};

export const formatTime = (timeString) => {
  if (!timeString) return ""; // Return an empty string if timeString is null or undefined

  const [hours, minutes, seconds] = timeString.split(/[:.]/); // Extract hours, minutes, and seconds
  const hourInt = parseInt(hours, 10); // Parse hours as integer
  const period = hourInt >= 12 ? "PM" : "AM"; // Determine AM or PM
  const hourFormatted = hourInt % 12 || 12; // Convert hours to 12-hour format

  return `${hourFormatted}:${minutes} ${period}`; // Format as HH:MM AM/PM
};
